// src/data/skills.js
import AccessibilitySvg from '../assets/Accessibility.svg';
import ReactSvg        from '../assets/ReactSvg.svg';
import ReactNativeSvg  from '../assets/React-Native.svg';
import VueSvg          from '../assets/VueSvg.svg';
import NodeJSSvg       from '../assets/NodeJS.svg';
import GraphQLSvg      from '../assets/GraphQLSvg.svg';
import TypescriptSvg   from '../assets/TypescriptSvg.svg';
import ThreeJSSvg      from '../assets/ThreeJSImg.svg';

export const skills = [
  { text: 'GraphQL',       color: '#E84170', image: GraphQLSvg,      imageDescription: 'GraphQL logo' },
  { text: 'React Native',  color: '#00FFE0', image: ReactNativeSvg,  imageDescription: 'React Native logo' },
  { text: 'React',         color: '#4ACAF2', image: ReactSvg,        imageDescription: 'React logo' },
  { text: 'Typescript',    color: '#2F74C0', image: TypescriptSvg,   imageDescription: 'Typescript logo' },
  { text: 'Vue',           color: '#47CA8C', image: VueSvg,          imageDescription: 'Vue logo' },
  { text: 'NodeJS',        color: '#8BBF3D', image: NodeJSSvg,       imageDescription: 'NodeJS logo' },
  { text: 'WCAG', color: '#FFFFFF', image: AccessibilitySvg, imageDescription: 'Accessibility logo' },
  { text: 'ThreeJS',       color: '#D728D7', image: ThreeJSSvg,      imageDescription: 'ThreeJS logo' },
];
